// @ts-ignore
import {createSelector} from 'reselect';
// @ts-ignore
import type {InputSelector} from 'reselect';
import type {ActivityType} from '../types';
import {Collections} from '../collections';
import type {CollectionState} from '../collections';

type ActivityTypesModuleState = {
    activityTypes: CollectionState<ActivityType>;
};

const EMAIL_TYPE__ID = '4-activityTypes';
const NOTE_TYPE__ID = '5-activityTypes';

// Hardcoded ids used for reporting, but shouldn't be selectable
// for logging purposes in the UI
const NON_LOGGABLE_IDS = [EMAIL_TYPE__ID, NOTE_TYPE__ID];

/*
 * Given the entire redux state, pull out just the piece of state for the activityTypes reducer.
 */
const getActivityTypesState = (state: ActivityTypesModuleState) => state.activityTypes;

export const getAll: InputSelector<ActivityTypesModuleState, any, ActivityType[]> =
    Collections.makeGetModels(getActivityTypesState);

/*
 * Get an array of all loggable activityTypes models
 */
export const getAllLoggable = createSelector([getAll], (loggables) => {
    // @ts-ignore
    const allLoggables = loggables.filter((loggable) => !NON_LOGGABLE_IDS.includes(loggable.id));

    return (
        allLoggables
            .slice(0, 3)
            // @ts-ignore
            .concat(allLoggables.slice(3).sort((a, b) => (a.name < b.name ? -1 : 1)))
    );
});

/*
 * Get the `byId` portion of the activityTypes state
 */
export const getById = (state: ActivityTypesModuleState) => {
    const activityTypesState = getActivityTypesState(state);

    return Collections.getById(activityTypesState);
};
